import React from 'react';
import classNames from 'classnames';

import { startStripeIdentityPath } from '../../util/api';
import {
  IDENTITY_TIPS,
  NEEDS_RETRY_TITLE,
  RETRY_BUTTON,
  identityReasonText,
} from '../../util/identityStatus';

import css from './IdentityRetryNotice.module.css';

/**
 * "ID check needs another try" card with Stripe's reason in plain words and
 * one clear retry button. Used on the dashboard and the onboarding ID step.
 *
 * @param {Object} props
 * @param {string} [props.reason] doc_type | expired | unreadable | selfie | generic
 * @param {string} [props.className]
 * @param {string} [props.headingLevel] 'h1' | 'h2' | 'h3'
 * @returns {JSX.Element}
 */
const IdentityRetryNotice = props => {
  const { reason, className, headingLevel = 'h2' } = props;
  const Heading = headingLevel;
  const headingId = 'identity-retry-title';
  const reasonId = 'identity-retry-reason';
  return (
    <section
      className={classNames(css.root, className)}
      aria-labelledby={headingId}
      data-identity-retry={reason || 'generic'}
    >
      <Heading id={headingId} className={css.title}>
        {NEEDS_RETRY_TITLE}
      </Heading>
      <p id={reasonId} className={css.reason}>
        {identityReasonText(reason)}
      </p>
      <p className={css.tips}>{IDENTITY_TIPS}</p>
      <a className={css.retry} href={startStripeIdentityPath()} aria-describedby={reasonId}>
        {RETRY_BUTTON}
      </a>
    </section>
  );
};

export default IdentityRetryNotice;
